<template>
  <div>
    <form-field-input
      v-autofocus
      label="Label"
      v-model="form.label"
      :validation-errors="validationErrors.label"
      autofocus
    ></form-field-input>

    <form-field-textarea
      label="Description"
      v-model="form.description"
      :validation-errors="validationErrors.description"
    ></form-field-textarea>
  </div>
</template>

<script>
import {FormMixin} from "./forms.mixin";
import utils from "../services/utils";
import api from "../api";

export default {
  name: "TaskListForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        label: null,
        description: null
      },
    }
  },
  created() {
    this.form = (this.formData) ? utils.clone(this.formData) : utils.clone(this.defaultForm);
  },
  methods: {
    update() {
      return api.taskLists.update(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Task list was updated',
            type: 'is-success'
          });

          return res;
        });
    },
    create() {
      return api.taskLists.create(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Task list was created',
            type: 'is-success'
          });

          return res;
        });
    },
    delete() {
      return api.taskLists.delete(this.form.id)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Task list was archived',
            type: 'is-success'
          });

          return res;
        });
    },
  },
}
</script>

<style scoped lang="scss">

</style>
